// extracted by mini-css-extract-plugin
module.exports = {"logo":"jgp-oDFJG"};